import { render, staticRenderFns } from "./AccreditationsList.vue?vue&type=template&id=d45b7000&scoped=true&"
import script from "./AccreditationsList.vue?vue&type=script&lang=js&"
export * from "./AccreditationsList.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationsList.vue?vue&type=style&index=0&id=d45b7000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45b7000",
  null
  
)

export default component.exports